// src/pages/Work/Overview/Overview.js
import React from 'react';
import './Overview.css';

function Overview() {
  return (
    <div className="section-container">
      {/* Main heading and subtitle */}
      <h2 className="main-heading">
        Overview <span className="heading-subtitle">Project Summary</span>
      </h2>

      {/* Client / Sector / Role / Time / Tools */}
      <div className="project-info">
        <div className="info-row">
          <div className="info-label">Client:</div>
          <div className="info-value">Siemens Digital Logistics</div>
        </div>
        <div className="info-row">
          <div className="info-label">Sector:</div>
          <div className="info-value">Logistics, Software as a Service (SaaS)</div>
        </div>
        <div className="info-row">
          <div className="info-label">My role:</div>
          <div className="info-value">UX Designer, UX Researcher, UI Designer</div>
        </div>
        <div className="info-row">
          <div className="info-label">Time:</div>
          <div className="info-value"><span className="blue-text">5 years</span></div>
        </div>
        <div className="info-row">
          <div className="info-label">Tools:</div>
          <div className="info-value">Figma, Adobe, Jira, Confluence</div>
        </div>
      </div>

      {/* Intro Paragraphs */}
      <p style={{ marginBottom: '1rem' }}>
        As a <strong>UX/UI designer</strong>, I work on a logistics and <strong>supply chain management platform</strong> that was originally developed 20 years ago to optimize and streamline transportation and logistics processes.
      </p>
      <p>
        The platform offers <strong>a cloud-based solution</strong> for collaboration, data exchange, and process management across supply chain partners. <strong>The most leading companies in the world</strong> use this logistics software on a large scale. This software as a service (SaaS) allows 500.000 users to manage their supply chains
      </p>
      {/* Key Features */}
      <h3 className="subheading-blue">
        Key Features of this app:
      </h3>
      <ul className="list">
        <li><strong>Shipment Tracking:</strong> Real-time visibility of shipments and deliveries.</li>
        <li><strong>Document Management:</strong> Centralized access to transport documents and data.</li>
        <li><strong>Process Automation:</strong> Automates logistics workflows to improve efficiency.</li>
        <li><strong>Collaboration Tools:</strong> Facilitates communication between suppliers, carriers, and customers.</li>
        <li><strong>Integration Capabilities:</strong> Connects with other systems like ERP, TMS, and WMS.</li>
      </ul>
    </div>
  );
}

export default Overview;